import { GetEpAgreementWallContextQuery } from '../../../graphql/queries/getEpAgreementWallContext.gql';

export const getIsRegistrationDateDone = (
  moduleData: GetEpAgreementWallContextQuery,
) => {
  // Some Shine Starts could still be waiting for their registration papers,
  // so we don’t want to ask them for their registration date.
  // We will follow up for the missing data afterwards
  // cf https://shinetools.slack.com/archives/C028ZMUJ8PK/p1650362131485469?thread_ts=1650361809.877739&cid=C028ZMUJ8PK
  if (moduleData.viewer.company.isShineStart) {
    return true;
  }

  return !!moduleData.viewer.company.profile.registrationDate;
};
